import React, { useEffect, useState } from "react";
import { IoBagHandleOutline } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const ShopCardList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]); // ✅ for categories

  // 🔹 Extract sellerId from URL
  const queryParams = new URLSearchParams(location.search);
  const sellerId = queryParams.get("sellerId");

  useEffect(() => {
    if (!sellerId) {
      setError("Seller ID not provided in the URL.");
      return;
    }

    const fetchProducts = async () => {
      setLoading(true);
      setError(null);

      try {
        const token =
          sessionStorage.getItem("accessToken") ||
          localStorage.getItem("accessToken");

        if (!token) {
          setError("Authentication token missing. Please log in.");
          setLoading(false);
          return;
        }

        const response = await fetch(
          `${API_BASE_URL}/buyer/get-products`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token: token,
            },
            body: JSON.stringify({
              filters: { seller_id: Number(sellerId) },
              page: 1,
              limit: 10,
            }),
          }
        );

        const data = await response.json();

        if (response.ok && data.success && Array.isArray(data.result?.products)) {
          setProducts(data.result.products);
        } else {
          setError(data?.message || "Failed to load products.");
        }
      } catch (err) {
        console.error("Error fetching products:", err);
        setError("Something went wrong while fetching products.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [sellerId]);


useEffect(() => {
  const fetchCategories = async () => {
    try {
      const token =
        sessionStorage.getItem("accessToken") ||
        localStorage.getItem("accessToken");

      if (!token) {
        console.warn("Token missing for categories API.");
        return;
      }

      const response = await fetch(
        `${API_BASE_URL}/product_category/get-categories`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            filters: {},
            page: 1,
            limit: 10,
          }),
        }
      );

      const data = await response.json();
      console.log("Category API Response:", data);

      // ✅ Handle both possible keys (categories or ProductCategories)
      const categoriesData =
        data?.result?.categories ||
        data?.result?.ProductCategories ||
        [];

      if (response.ok && data.success && Array.isArray(categoriesData)) {
        setCategories(categoriesData);
      } else {
        console.error("Failed to load categories:", data);
        setCategories([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  };

  fetchCategories();
}, []);


  if (loading) return <div className="p-6 text-gray-600">Loading products...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;
  if (!products.length)
    return <div className="p-6 text-gray-600">No products found.</div>;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Filters */}
      <div className="flex justify-between items-center mb-6 flex-wrap gap-3">
        <div className="flex gap-3">
         {/* ✅ Dynamic category dropdown */}
          <select className="border px-4 py-2 rounded-full">
            <option value="">All Categories</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.title}
              </option>
            ))}
          </select>
          <select className="border px-4 py-2 rounded-full">
            <option>Offers</option>
          </select>
        </div>
        <div className="flex gap-3">
          <input
            type="text"
            placeholder="Search products"
            className="border px-4 py-2 rounded-full"
          />
          <select className="border px-4 py-2 rounded-full">
            <option>Sort by</option>
            <option>Today</option>
            <option>Weekly</option>
            <option>Monthly</option>
          </select>
        </div>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {products.map((product, index) => (
          <ProductCard product={product} key={index} />
        ))}
      </div>
    </div>
  );
};

export default ShopCardList;

function ProductCard({ product }) {
  const navigate = useNavigate();

 const handleBuyNow = (productId) => {
   navigate(`/ProductView/${productId}`, {
      state: { productId },
    });
    console.log("productId",productId)
  };

  return (
    <div className="p-2">
      <div className="relative bg-[#FAFAFA] rounded-lg shadow-sm">
        <div className="w-full h-[170px]">
          <img
            src={product.product_media?.[0]?.url || "/image/shoeimg.png"}
            alt={product.product_name}
            className="w-full h-full object-contain rounded-t-lg"
          />
        </div>

        {product.offer_percentage && (
          <span className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
            {product.offer_percentage}% Offer
          </span>
        )}
      </div>

      <p className="mt-4 text-sm text-gray-600 uppercase line-clamp-2">
        {product.product_name}
      </p>

      <div className="flex justify-between items-center">
        <div className="flex flex-col">
          <span className="line-through text-gray-400 text-sm">
            ${product.product_price}
          </span>
          <span className="text-black font-semibold">
            ${product.discount_price}
          </span>
        </div>

        <button
          onClick={handleBuyNow}
          className="mt-3 flex py-2 px-3 text-[14px] gap-2 items-center bg-gray-900 text-white rounded-full"
        >
          <IoBagHandleOutline className="text-lg" />
          ADD TO CART
        </button>
      </div>
    </div>
  );
}
